<template>
    <div class="main-header grid grid__base">
        <aside class="main-header--top">
            <div class="main-header--container grid--container">
                <div class="main-header--top-row grid--row">
                    <div class="main-header--metanav grid--col">
                        <meta-navigation :children="meta.items"/>
                    </div>
                    <div class="main-header--languages grid--col">
                        <language-menu :children="language.children"/>
                    </div>
                </div>
            </div>
        </aside>
        <header class="main-header--bottom">
            <div class="main-header--container grid--container">
                <div class="main-header--bottom-row grid--row">
                    <div class="main-header--logo grid--col">
                        <app-logo v-bind="home.content"/>
                    </div>
                    <div class="main-header--menu grid--col">
                        <main-menu :children="menu.items"/>
                    </div>
                    <div class="main-header--hamburger">
                        <hamburger/>
                    </div>
                </div>
            </div>
        </header>
    </div>
</template>

<script>
    import MetaNavigation from './meta-navigation/meta-navigation';
    import LanguageMenu from 'framework/components/language-menu/language-menu';
    import AppLogo from 'framework/components/app-logo/app-logo';
    import MainMenu from 'framework/components/main-menu/main-menu';
    import Hamburger from './hamburger/hamburger';

    export default {
        components: { Hamburger, MainMenu, AppLogo, LanguageMenu, MetaNavigation },
        props: {
            menu: {
                type: Object,
                required: true,
            },
            language: {
                type: Object,
                required: true,
            },
            home: {
                type: Object,
                required: true,
            },
            meta: {
                type: Object,
                required: true,
            },
        },
    };
</script>
